// chats.effects.ts
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap, switchMap } from 'rxjs/operators';
import { CrudService } from 'src/app/core/services/crud.service';
import { loadChatUsers, loadChatUsersSuccess, loadChatUsersFailure, loadMessages, loadMessagesSuccess, loadMessagesFailure, sendMessage, addMessage } from './chats.action';

@Injectable()
export class ChatEffects {
  constructor(
    private actions$: Actions,
    private crudService: CrudService
  ) {}

  loadUsers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadChatUsers),
      mergeMap((action) =>
        this.crudService.fetchData(`Messages/GetUsersWithChat?userId=${action.id}`).pipe(
          map(users => loadChatUsersSuccess({ users })),
          catchError(error => of(loadChatUsersFailure({ error: error.message || 'Failed to load users' })))
        )
      )
    )
  );

  loadMessages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadMessages),
      mergeMap(({ senderId, receiverId }) =>
        this.crudService.fetchData(`Messages/${senderId}/${receiverId}`).pipe(
          map(messages => loadMessagesSuccess({ messages })),
          catchError(error => of(loadMessagesFailure({ error: error.message || 'Failed to load messages' })))
        )
      )
    )
  );

  sendMessage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(sendMessage),
      switchMap(({ message }) =>
        this.crudService.postData('Messages/SendMessage', message).pipe(
          map((response) => {
            // Add the message with server-generated ID if available
            const messageWithId = response?.id ? { ...message, id: response.id } : message;
            return addMessage({ message: messageWithId });
          }),
          catchError(error => {
            console.error('Failed to send message:', error);
            return of(loadMessagesFailure({ error: error.message || 'Failed to send message' }));
          })
        )
      )
    )
  );
}
